import { translate } from "$lib/utilities/translate";
import { slugify } from "cando-util";

export const getSections = (setting, lang, pathname) => {
	const sectionKeys = Object.keys(setting)
		.filter((k) => setting[k]?.value?.type?.value === "section");
	const configuredOrder = String(setting?.general?.value?.sectionOrder?.value || '')
		.split('+||+')
		.filter((key, index, keys) => sectionKeys.includes(key) && keys.indexOf(key) === index);
	return [...configuredOrder, ...sectionKeys.filter((key) => !configuredOrder.includes(key))]
		.map((k) => ({
			...setting[k].value,
			key: k,
			id: slugify(setting[k].value.label?.value),
			class: "",
			label: translate(setting[k].value.label, lang),
			questions: (setting[k].value.questions?.value || '')
				.replace(/\+\|\|\+/g, '\n')
				.split('\n')
				.filter(q => !!q && !!setting[q]?.value && typeof setting[q].value === 'object')
				.map((q) => Object.keys(setting[q].value || {})
					.sort()
					.reverse()
					.reduce((a, k) => ({
						...a,
						[k.replace(pathname, '')]: setting[q].value[k]
					}), { questionId: q })
				)
		}));
};
